if (!customElements.get('collection-infinite-scroll')) {
  class CollectionInfiniteScroll extends HTMLElement {
    #observer = null;
    #loading = false;
    #abortController = null;

    connectedCallback() {
      this.#observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              this.#loadNextPage();
            }
          }
        },
        { rootMargin: '400px 0px' }
      );

      this.#observer.observe(this);
    }

    disconnectedCallback() {
      this.#observer?.disconnect();
      this.#abortController?.abort();
    }

    async #loadNextPage() {
      if (this.#loading) return;

      const nextUrl = this.dataset.nextUrl;
      if (!nextUrl) {
        this.remove();
        return;
      }

      this.#loading = true;
      this.classList.add('is-loading');

      this.#abortController?.abort();
      this.#abortController = new AbortController();

      try {
        const url = new URL(nextUrl, window.location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);

        const response = await fetch(url.toString(), {
          signal: this.#abortController.signal,
        });

        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const newProducts = doc.querySelectorAll('product-list > *');
        const currentList = this.closest('.collection').querySelector('product-list');

        if (currentList && newProducts.length > 0) {
          for (const product of newProducts) {
            currentList.appendChild(document.importNode(product, true));
          }
        }

        const newSentinel = doc.querySelector('collection-infinite-scroll');

        if (newSentinel?.dataset.nextUrl) {
          this.dataset.nextUrl = newSentinel.dataset.nextUrl;
        } else {
          this.#observer?.disconnect();
          this.remove();
          return;
        }
      } catch (error) {
        if (error.name === 'AbortError') return;
        console.error('Infinite scroll load failed:', error);
      } finally {
        this.#loading = false;
        this.classList.remove('is-loading');
      }
    }
  }

  customElements.define('collection-infinite-scroll', CollectionInfiniteScroll);
}
